import { Box } from '@hivebrite/design-system/Box';

import { Price } from 'hb-react/shared/apps/Events/components/Price';
import { getTicketDisponibility } from 'hb-react/shared/apps/Events/utils/getTicketDisponibility';

const Ticket = ({ ticket, children }) => (
  <Box
    flexDirection={{ _: 'column', m: 'row' }}
    flexGrow={2}
    alignItems={{ m: 'center' }}
  >
    <Box flexDirection="column" flexGrow={2}>
      <Box mb={1} alignItems="center">
        <Box font="h4-semibold">{ticket.name}</Box>
        <Box>
          &nbsp;
          {getTicketDisponibility(
            ticket.quantity_available,
            ticket.unlimited,
            ticket.sold_out,
            ticket.has_expired,
            ticket.limit_reached_for_current_user,
          )}
        </Box>
      </Box>
      <Box>{ticket.description}</Box>
    </Box>
    <Box pl={{ _: 0, m: 6 }} font="h4-semibold" mt={{ _: 1, m: 'unset' }}>
      <Price price={ticket.price} currency={ticket.currency} />
    </Box>
    {children}
  </Box>
);

export default Ticket;
